import { combineReducers } from 'redux';
import customerReducer from './reducers/customerReducer.js';
import batchReducer from './reducers/batchReducer.js';
import userReducer from './reducers/userReducer.js';
import taskReducer from './reducers/taskReducer.js';
import groupReducer from './reducers/groupReducer.js';
import batchGroupReducer from './reducers/bacthGroupReducer.js';
import authReducer from './reducers/authReducer.js';
import configReducer from './reducers/configReducer.js';
import knowledgeBaseReducer from './reducers/knowledgeBaseReducer.js';
import settingsReducer from './reducers/settingsReducer.js';
import projectReducer from './reducers/projectReducer.js';
import departmentReducer from './reducers/departmentReducer.js';
import physicianReducer from './reducers/physicianReducer.js';
import stateReducer from './reducers/stateReducer.js';
import payerReducer from './reducers/payerReducer.js';
import ruleReducer from './reducers/ruleReducer.js';
import patientReducer from './reducers/patientReducer.js';
import insuranceReducer from './reducers/insuranceReducer.js';
import visitReducer from './reducers/visitReducer.js';
import encounterReducer from './reducers/encounterReducer.js';
import diagnosisReducer from './reducers/diagnosisReducer.js';
import serviceReducer from './reducers/serviceReducer.js';
import icdReducer from './reducers/icdReducer.js';
import cptReducer from './reducers/cptReducer.js';
import hcpcReducer from './reducers/hcpcReducer.js';
import claimReducer from './reducers/claimReducer.js';
import agentReducer from './reducers/agentReducer.js'
import promptReducer from './reducers/promptReducer.js';
import modelReducer from './reducers/modelReducer.js';
import testCaseReducer from './reducers/testCaseReducer.js';
import ApikeyReducer from './reducers/apikeyReducer.js';
import DashboardReducer from './reducers/dashboardReducer.js'
import processorReducer from './reducers/processorReducer.js';
import organizationReducer from './reducers/organizationReducer.js';
import switchOrganizationReducer from './reducers/switchOrganizationReducer.js';
const rootReducer = combineReducers({
  auth: authReducer,  
  customer: customerReducer,
  batch:batchReducer,
  user:userReducer,
  task:taskReducer,
  group:groupReducer,
  batchGroup:batchGroupReducer,
  settings:settingsReducer,
  config:configReducer,
  knowledgeBase:knowledgeBaseReducer,
  project:projectReducer,
  department:departmentReducer,
  physician:physicianReducer,
  state:stateReducer,
  payer:payerReducer,
  rule:ruleReducer,
  patient:patientReducer,
  insurance:insuranceReducer,
  visit:visitReducer,
  encounter:encounterReducer,
  diagnosis:diagnosisReducer,
  service:serviceReducer,
  icd:icdReducer,
  cpt:cptReducer,
  hcpc:hcpcReducer,
  claim:claimReducer,
  agent:agentReducer,
  prompt:promptReducer,
  model: modelReducer,
  testCase:testCaseReducer,
  apikey: ApikeyReducer,
  dashboard:DashboardReducer,
  process:processorReducer,
  organization:organizationReducer,
  switchOrganization:switchOrganizationReducer
});

export default rootReducer;
